import { Navigate } from 'react-router-dom';
import { Spinner } from '@design-system';
import { useConsumerPlan } from './hooks/use-consumer-plan';
import { FIRST_CONSUMER_STEP, currentConsumerStep } from './lib/steps';
import { consumerStepPath } from './lib/paths';

/** Sends a consumer to where they left off, or to the start of the flow. */
export function ConsumerFlowEntry({ clientId }: { clientId: string }) {
  const { plan, isLoading } = useConsumerPlan(clientId);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="size-6" />
      </div>
    );
  }

  const step = currentConsumerStep(plan?.lastStep) ?? FIRST_CONSUMER_STEP;
  return <Navigate to={consumerStepPath(clientId, step)} replace />;
}
